import CurrentAffairsHome from "../shared/components/Current-Affairs/Homedata";

export default function CurrentAffHomePage () {

    return (
        <>
        <CurrentAffairsHome/>
        </>
    )
}